/* Shared variant-selection state. Kept separate from shipping integrations. */
(function () {
	window.receivedDataVariantSku = function (sku) {
		window.dataVariantSku = sku;
	};

	window.receivedDataVariantTitle = function (title) {
		window.dataVariantTitle = title;
	};

	window.setQualitySelectedType = function (selectedType) {
		window.qualitySelectedType = selectedType;
	};
})();
